<template>
  <div v-if="loading" class="text-center font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" />
  </div>

  <div v-else class="animated">
    <div>
      <b-row class="mb-3">
        <b-col>
          <b-input-group prepend="Crop Type">
            <b-form-select
              v-model="attribute_list_value"
              :options="cropOptions"
            >
              <template #first>
                <option :value="null">
                  Select Crop Type
                </option>
              </template>
            </b-form-select>
          </b-input-group>
        </b-col>
      </b-row>

      <AnalyteRangeFormTissueEdit
        :analyte_ranges="analyte_ranges"
        :loading_analyte_ranges="loading_analyte_ranges"
        @refresh="fetchAnalyteRanges"
      />

      <b-card v-if="addingNew" no-body>
        <b-card-header>
          <span class="text-muted text-uppercase">Add Analyte Range</span>
        </b-card-header>

        <b-card-body>
          <AnalyteRangeFormTissueAdd
            :analyte="analyte"
            :selected_attribute_list_value="attribute_list_value"
            :selected_sub_attribute_list_value="sub_attribute_list_value"
            :crop_options="cropOptions"
            :crop_stage_options="cropStageOptions"
            @close="addingNew = false"
            @saved="onSave"
          />
        </b-card-body>
      </b-card>

      <b-button v-else block variant="primary" @click="addingNew = true">
        <i class="fa fa-plus" /> Add Analyte Range
      </b-button>
    </div>
  </div>
</template>

<script>
import { getCollection } from '@/shared/fetch-utils'
import AnalyteRangeFormTissueEdit from './fields/AnalyteRangeFormTissueEdit.vue'
import AnalyteRangeFormTissueAdd from './fields/AnalyteRangeFormTissueAdd.vue'

export default {
  name: 'AnalyteRangeFormTissue',
  components: {
    AnalyteRangeFormTissueEdit,
    AnalyteRangeFormTissueAdd
  },
  props: {
    analyte: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      loading: true,
      analyte_id: this.analyte.id,

      managed_list_collection: null,
      attribute_list_value: null,
      sub_attribute_list_value: null,

      loading_analyte_ranges: true,
      analyte_range_collection: null,
      analyte_ranges: [],

      addingNew: false,
    }
  },
  computed: {
    managedLists () {
      return this.managed_list_collection &&
        this.managed_list_collection.models &&
        this.managed_list_collection.models.length
        ? this.managed_list_collection.models
        : []
    },

    cropTypes () {
      return this.managedLists.find(
        item => item.sub_type === 'tissue' && item.list === 'type'
      ).attribute_lists
    },

    cropOptions () {
      return this.cropTypes.map((attribute) => {
        return {
          value: attribute.id,
          text: attribute.value
        }
      })
    },

    cropStages () {
      return this.managedLists.find(
        item => item.sub_type === 'tissue' && item.list === 'growth_stage'
      ).attribute_lists
    },

    cropStageOptions () {
      return this.cropStages.map((attribute) => {
        return {
          value: attribute.id,
          text: attribute.value
        }
      })
    }
  },
  watch: {
    attribute_list_value: {
      handler () {
        this.fetchAnalyteRanges()
      }
    }
  },
  async created () {
    this.loading = true

    await this.fetchAnalyteRanges()

    this.managed_list_collection = await getCollection({
      collection_type: 'managed_list',
      message: this.$bvToast,
      limit: 'all',
    })

    this.loading = false
  },
  methods: {
    async fetchAnalyteRanges () {
      this.loading_analyte_ranges = true

      const filters = [
        {
          logic: 'filterEquals',
          field: 'analyte_id',
          value: this.analyte_id
        }
      ]

      if (this.attribute_list_value) {
        filters.push({
          logic: 'filterEquals',
          field: 'attribute_list_id',
          value: this.attribute_list_value
        })
      }

      this.analyte_range_collection = await getCollection({
        collection_type: 'analyte_range',
        filters
      })

      this.analyte_ranges = this.analyte_range_collection.map((analyte_range) => {
        return {
          id: analyte_range.id,
          analyte: analyte_range.analyte,
          analyte_id: analyte_range.analyte_id,
          attribute_list_id: analyte_range.attribute_list_id,
          attribute_list: analyte_range.attribute_list,
          sub_attribute_list_id: analyte_range.sub_attribute_list_id,
          sub_attribute_list: analyte_range.sub_attribute_list,
          low: analyte_range.low,
          high: analyte_range.high
        }
      })

      this.loading_analyte_ranges = false
    },

    onSave () {
      this.addingNew = false
      this.fetchAnalyteRanges()
    }
  }
}
</script>
